module.exports = __webpack_public_path__ + "static/media/OAO_Banner2.a9848703.png";